<template lang="html">
  <pl-dialog maxWidth="700px" minHeight="800px" @close="$emit('close')">
    <div style="padding: 0 80px">
      <div>
        <h1>Update Keywords</h1>
      </div>
      <div class="flex row justify-center">
        <p class="row pl-subheading">
          A refined word cloud is better. We recommend removing <br />
          keywords that are too generic to provide relevant insights.
        </p>
      </div>
      <div class="user-container" style="width: 93%; margin-top: 10px">
        <table style="width: 97%; text-align: center">
          <tr style="height: 30px">
            <th>Included?</th>
            <th>Keyword</th>
            <th>Occurrences</th>
          </tr>
          <tr
            v-for="word in Object.keys(keywords)"
            class="border_bottom"
            style="height: 40px"
          >
            <td v-if="word !== 'l'">
              <pl-checkbox
                v-model="keywords[word]['removed']"
                @click="keywords[word]['removed'] = !keywords[word]['removed']"
                style="margin-left: 50px"
              />
            </td>
            <td v-if="word !== 'l'">{{ word }}</td>
            <td v-if="word !== 'l'">{{ keywords[word]['freq'] }}</td>
          </tr>
        </table>
      </div>
      <div class="options">
        <table style="width: 100%; text-align: center; margin-top: 30px">
          <tr>
            <td style="width: 50%" @click="closeMenu()">
              <pl-button>Cancel</pl-button>
            </td>
            <td style="width: 50%" @click="sendDataBack()">
              <pl-button class="pl-primary"
                >Save and Update Word Cloud</pl-button
              >
            </td>
          </tr>
        </table>
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import plDialog from 'src/app/components/material/components/plDialog/plDialog';
  import plButton from 'src/app/components/material/components/plButton/plButton';
  import { EventBus } from 'utils/event-bus';

  export default {
    name: 'roundtableNlpWordCloudEditKeywords',
    components: {
      plDialog,
      plButton,
    },
    data() {
      return {
        model: [],
      };
    },
    props: {
      keywords: {
        type: Object,
        default() {
          return null;
        },
      },
    },
    methods: {
      closeMenu() {
        EventBus.$emit('closeWordList');
      },
      sendDataBack() {
        let keys = Object.keys(this.keywords);
        const len = keys.length > 80 ? 80 : keys.length;
        for (let i = 0; i < len; i++) {
          const word = keys[i];
          if (word !== 'l') {
            this.keywords[word]['removed'] = this.keywords[word]['removed']
              ? 'False'
              : 'True';
          }
        }

        this.$store.dispatch('updateKeywords', {
          keywords: JSON.stringify(this.keywords),
        });

        EventBus.$emit('updateWordList', this.keywords);
      },
    },
    mounted() {
      let keys = Object.keys(this.keywords);
      const len = keys.length > 80 ? 80 : keys.length;
      for (let i = 0; i < len; i++) {
        const word = keys[i];
        if (word !== 'l') {
          this.keywords[word]['removed'] = this.keywords[word]['removed'] === 'False';
        }
      }
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl';

  .user-container
    overflow-y: scroll
    text-align: left
    height: 550px
    width: 475px
    margin-left: 20px
  &&::-webkit-scrollbar {
      display: block;
      width: 6px;
      margin-right: 2px
    }
  .text-container
    text-overflow: ellipsis
    white-space: nowrap
    overflow: hidden

  #share-activity .modal-content {
    overflow: scroll;
  }

  table {
    border-collapse: collapse;
  }

  tr.border_bottom td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
</style>



// WEBPACK FOOTER //
// roundtableNlpWordCloudEditKeywords.vue?d10dbec4